import * as React from 'react'
import {cn} from '@frontrow/console/src/lib/utils'

type Props = {
  children?: React.ReactNode
  addClass?: string
  id?: string
  htmlElement?: 'div' | 'section'
}

export function Card({children, addClass, id, htmlElement = 'div'}: Props): React.ReactElement {
  return React.createElement(
    htmlElement,
    {
      id,
      className: cn('rounded-lg border border-border bg-card p-6 text-card-foreground', addClass)
    },
    children
  )
}
